import React from "react"
import splashImg from '../assets/xxxx/BaoBounty_brand_logo_mark_tiny_cute_steamed_bao_b-1776448119303.png'
import './LaunchScreen.css'
class LaunchScreen extends React.Component{
    render(){
        return(
            <div className="LaunchScreenV">
                <div className="splashContainer">
                    <div className="splashDecorTop"></div>
                    <img src={splashImg} className="splashLogo" alt="BaoBounty"></img>
                    <div className="splashBrand">
                        <h1 className="splashBrandName">BaoBounty</h1>
                        <p className="splashBrandTagline">Earn while you discover</p>
                    </div>
                </div>
            </div>
        )
    }
}
export default LaunchScreen